import React, { useState } from "react";
import { useAPIs } from "../apis/APIsConfig";
import { isFallecido } from "../services/affiliate";
import { useForm } from "../utils/hooks";
import InputMask from "react-input-mask";
import WithMainLayout from "../hocs/layouts/MainLayout";
import Constants from "../utils/constants";

const DeceasedAffiliate = () => {
  useAPIs();

  const [formState, setError, changeHandler, reset] = useForm({
    Cedula: "",
  });
  const [fallecido, setFallecido] = useState<any>();
  const [showMessage, setShowMessage] = useState<boolean>(false);

  function disableButton() {
    return formState.data.Cedula.replaceAll("_", "").length !== 11;
  }

  function submitForm() {
    isFallecido(formState.data.Cedula).then((res) => {
      if (res) {
        if (res.data.value.esFallecido && res.data.value.esAfiliado) {
          setFallecido(res.data.value);
        } else {
          setShowMessage(true);
        }
      }
    });
  }

  return (
    <section className="content-consultation-deceased-affiliate">
      <div className="container">
        <div className="description">
          <div
            className="title wow fadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay="0.4s"
          >
            <p>
              Utiliza esta consulta para verificar si tu familiar estaba
              afiliado con nosotros. Por favor digita el número de la cédula de
              identidad de tu familiar fallecido.
            </p>
            <p>
              Si ya sabías que tu familiar estaba afiliado con nosotros,
              consulta los requisitos para la Pensión por Sobrevivencia{" "}
              <a
                target="_blank"
                href={Constants.RESOURCESURLS.PENSION_SOBREVIVENCIA}
              >
                aquí.
              </a>
            </p>
          </div>
          {!fallecido && !showMessage && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="form-deceased-affiliate wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.5s"
            >
              <div className="form-group">
                <label>Documento de Identidad</label>
                <InputMask
                  type="text"
                  className="form-control large"
                  placeholder="Ingresa tu documento"
                  value={formState.data.Cedula}
                  onChange={changeHandler("Cedula", undefined, "-")}
                  mask="999-9999999-9"
                  maskPlaceholder={"_"}
                />
                <small>&nbsp;</small>
              </div>
              <button
                type="button"
                onClick={submitForm}
                disabled={disableButton()}
                className="btn btn-primary btn-large w-full md:w-auto"
              >
                Consultar
              </button>
            </form>
          )}
          {fallecido && (
            <div className="deceased-member-information">
              <div className="title-member">
                <h5>Información del Afiliado fallecido</h5>
                <a
                  className="btn btn-secondary btn-medium md:btn-large"
                  onClick={() => {
                    setFallecido(null);
                    setShowMessage(false);
                  }}
                >
                  <i className="icon icon-arrow-left right"></i>Consultar
                </a>
              </div>
              <ul className="list-information">
                <li>
                  <p>Número de identificación</p>
                  <p>
                    <b>{fallecido.numIdentif}</b>
                  </p>
                </li>
                <li>
                  <p>Nombre y Apellido</p>
                  <p>
                    <b>
                      {fallecido.primerNombre} {fallecido.primerApellido}{" "}
                      {fallecido.segundoApellido}
                    </b>
                  </p>
                </li>
                <li>
                  <p>Edad</p>
                  <p>
                    <b>89</b>
                  </p>
                </li>
                <li>
                  <p>Correo Electrónico</p>
                  <p>
                    <b>{fallecido.correo}</b>
                  </p>
                </li>
                <li>
                  <p>Teléfono</p>
                  <p>
                    <b>{fallecido.telefono}</b>
                  </p>
                </li>
              </ul>
            </div>
          )}
          {showMessage && (
            <div className="deceased-member-information">
              <div className="title-member">
                <h5>Información del Afiliado fallecido</h5>
                <button
                  className="btn btn-secondary btn-medium md:btn-large"
                  onClick={() => {
                    setFallecido(null);
                    setShowMessage(false);
                  }}
                >
                  <i className="icon icon-arrow-left right"></i>Consultar
                </button>
              </div>
              <div>No es un afiliado fallecido</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WithMainLayout(DeceasedAffiliate);
